import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  DeleteLikedGoodsParams,
  DeleteLikedGoodsResponse,
} from './types';

/**
 * - 찜한 상품 일괄 삭제
 * - iOS `LikedProductRouter.deleteProducts` 와 동일
 *   (`DELETE /members/me/liked_goods/`, body: `{ like_snos }`)
 */
export const deleteLikedGoods = ({ snos }: DeleteLikedGoodsParams) => {
  return defaultHttpClient
    .request<DeleteLikedGoodsResponse>({
      method: 'DELETE',
      url: '/api/v2/members/me/liked_goods/',
      data: { like_snos: snos },
    })
    .then(result => result.data);
};
